import template2023 from "./txt/2023ndbg.txt";
import template2024 from "./txt/2024ndbg.txt"

export const reportTemplate = [
    {
        id: 2,
        title: "XXXX（单位名称）2024年政府信息公开工作年度报告",
        name: "2024年政府信息公开工作年度报告",
        code: template2024
    },
    {
        id: 1,
        title: "XXXX（单位名称）2023年政府信息公开工作年度报告",
        name: "2023年政府信息公开工作年度报告",
        code: template2023
    }
]